/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface SolrProjectReduced
 */
export interface SolrProjectReduced  {
    /**
     * 
     * @type {string}
     * @memberof SolrProjectReduced
     */
    id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SolrProjectReduced
     */
    name?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SolrProjectReduced
     */
    hierarchy?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SolrProjectReduced
     */
    partner?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SolrProjectReduced
     */
    gnd?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof SolrProjectReduced
     */
    recordCreationDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SolrProjectReduced
     */
    recordChangeDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof SolrProjectReduced
     */
    editorialStatus?: string;
}

/**
 * Check if a given object implements the SolrProjectReduced interface.
 */
export function instanceOfSolrProjectReduced(value: object): value is SolrProjectReduced {
    return true;
}

export function SolrProjectReducedFromJSON(json: any): SolrProjectReduced {
    return SolrProjectReducedFromJSONTyped(json, false);
}

export function SolrProjectReducedFromJSONTyped(json: any, ignoreDiscriminator: boolean): SolrProjectReduced {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
              'name': json['name'] == null ? undefined : json['name'],
              'hierarchy': json['hierarchy'] == null ? undefined : json['hierarchy'],
              'partner': json['partner'] == null ? undefined : json['partner'],
              'gnd': json['gnd'] == null ? undefined : json['gnd'],
                'recordCreationDate': json['recordCreationDate'] == null ? undefined : (new Date(json['recordCreationDate'])),
                'recordChangeDate': json['recordChangeDate'] == null ? undefined : (new Date(json['recordChangeDate'])),
                  'editorialStatus': json['editorialStatus'] == null ? undefined : json['editorialStatus'],
    };
}

export function SolrProjectReducedToJSON(json: any): SolrProjectReduced {
    return SolrProjectReducedToJSONTyped(json, false);
}

export function SolrProjectReducedToJSONTyped(value?: SolrProjectReduced | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'] == null? value['name']: value['name'],
        'hierarchy': value['hierarchy'] == null? value['hierarchy']: value['hierarchy'],
        'partner': value['partner'] == null? value['partner']: value['partner'],
        'gnd': value['gnd'] == null? value['gnd']: value['gnd'],
        'recordCreationDate': value['recordCreationDate']?.toISOString(),
        'recordChangeDate': value['recordChangeDate']?.toISOString(),
        'editorialStatus': value['editorialStatus'],
    };
}


